<div class="container main-layout">
    <div class="right-container">
        <div>
          <div class="rc-heading">
            <div class="DashHead">Dashboard</div>
        </div>
    <div class="DropdownSet">
    <div class="Dropdown">
        <mat-label class="LabelP">Timeframe </mat-label>
        <mat-select class="SelectD" (selectionChange)="optionSelected($event)" placeholder="Select" value="Today">
          <mat-option class="selectD-option" value="Today">Today</mat-option>
          <mat-option class="selectD-option" value="Current Week">Current Week</mat-option>
          <mat-option class="selectD-option" value="Last Week">Last Week</mat-option>
          <mat-option class="selectD-option" value="Last Month">Last Month</mat-option>
          <mat-option class="selectD-option" value="Last 6 Months">Last 6 Months</mat-option>
          <mat-option class="selectD-option" value="Last 1 Year">Last Year</mat-option>
         <!--  <mat-option value="Custom Date Range">Custom Date Range</mat-option> -->
        </mat-select>
    </div>
    <!-- <div class="FormD" *ngIf="CustomRange">
        <form [formGroup]="range" class="date-range-form">
          
            <mat-form-field appearance="fill">
              <input matInput [matDatepicker]="startPicker" formControlName="start" placeholder="Start date" (dateChange)="fromDate($event)">
              <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
              <mat-datepicker #startPicker></mat-datepicker>
            </mat-form-field>
          
            <mat-form-field appearance="fill">
              <input matInput [matDatepicker]="endPicker" formControlName="end" placeholder="End date" (dateChange)="toDate($event)">
              <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
              <mat-datepicker #endPicker></mat-datepicker>
            </mat-form-field>
          </form>    
        </div> -->
    </div>
          <div class="middleDiv">
            <div class="insideD-trainee" (click)="trainelist()" >
                <p class="TraineeP">Users</p>
                <p class="TraineeN">{{dashboardData.user_count || 0}}</p>
            </div>
            <div class="insideD">
                <p class="TraineeP">Chats</p>
                <p class="TraineeN">{{dashboardData.learning_count || 0}}</p>
            </div>
         <!--    <div class="insideD">
                <p class="TraineeP">DrQueryCoach</p>
                <p class="TraineeN">
                  <ng-container *ngFor="let keyValuePair of dashboardData.test_score | keyvalue; let last = last">
                    {{ keyValuePair.key || 0}}
                  </ng-container>
                  <span *ngIf="!dashboardData.test_score">0</span>
                </p>
            </div> -->
          <!--   <div class="insideD">
                <p class="TraineeP">Roleplays</p>
                <p class="TraineeN">
                <ng-container *ngIf="dashboardData.roleplay_scores !== null && dashboardData.roleplay_scores !== undefined">
                  <ng-container *ngFor="let keyValuePair of dashboardData.roleplay_scores | keyvalue; let last = last">
                    {{ keyValuePair.key || 0}}
                  </ng-container>
              </ng-container>
                <span *ngIf="!dashboardData.roleplay_scores">0</span>
                </p>
            </div> -->
           <!--  <div class="insideD">
              <p class="TraineeP" (click)="routtonew()">Avatar</p>
              <p class="TraineeN usage">
                {{dashboardData.avatar_consumption_percentage}}%
              </p>
              <ng-container></ng-container>
              <div class="consumption">
                {{dashboardData.avatar_consumption_time}}
              </div>
            </div> -->
         <!--  <div class="insideD">
            <p class="TraineeP" (click)="routtonew()">No of Users</p>
            <ng-container></ng-container>
            <div class="consumption">
              <p class="TraineeN usage">
                {{dashboardData.login_count}}</p>
            </div>
          </div> -->
         
          </div>
          <div *ngIf="showSessionCount" class="learning_count" >
            <div *ngFor="let key of objectKeys(dashboardData.user_types_count)">
              <p class="consumption">
                {{ key }} - {{ dashboardData.user_types_count[key] }}
              </p>
            </div>
          </div>  
          <div class="ChartD">

            <div class="piechart">
                <div class="button-div">
                    <!-- <button [ngClass]="test_version ? 'active-btn1' : 'inactive-btn1'" (click)="quiz()">
                        <span>Quizzes</span>
                    </button>
                    <button [ngClass]="test_version ? 'inactive-btn1' : 'active-btn1'" (click)="roleplay()">
                        <span>Roleplays</span>
                    </button> -->
                   
                    <span class="header-container">
                      <span class="pie-header">Logged-in Users</span>
                      <span class="timeframe">
                        <mat-label class="LabelP logged-users">Timeframe </mat-label>
                        <div class="DropdownPie">
                          <!-- <mat-label class="LabelP">Timeframe </mat-label> -->
                          <mat-select class="SelectD" (selectionChange)="onFramePieChart($event)" placeholder="Select" value="Today">
                            <mat-option class="selectD-option" value="Today">Today</mat-option>
                            <mat-option class="selectD-option" value="Current Week">Current Week</mat-option>
                            <mat-option class="selectD-option" value="Last Week">Last Week</mat-option>
                            <mat-option class="selectD-option" value="Last Month">Last Month</mat-option>
                            <mat-option class="selectD-option" value="Last 6 Months">Last 6 Months</mat-option>
                            <mat-option class="selectD-option" value="Last 1 Year">Last Year</mat-option>
                          </mat-select>
                        </div>
                      </span>
                    </span>
                    
                </div>
              <div class="insidePie">
                <div class="Pieframe">
                <canvas id="donutChart" class="CanvasPie"></canvas>
                </div>
                <div>
                  <div class="label" *ngFor="let key of labels; let i = index">
                    <span class="bullet" [ngStyle]="getStyle(i)"></span> {{key}}
                  </div>
                  <!-- <div class="label-container">
                    <div class="label" *ngFor="let key of labels; let i = index">
                      <span class="bullet" [ngStyle]="{'background-color': getStyle(i)}"></span>
                      {{ key }}: {{ values[i] }} users
                    </div>
                  </div> -->
                 <!--  
                  <div class="label">
                    <span class="bullet" style="background-color: blue;"></span> Lunch Cardiologist
                  </div>
                  
                  <div class="label">
                    <span class="bullet" style="background-color: gray;"></span> Volume Cardiologist
                  </div> -->
                </div>
            </div>
            </div>
            <div class="linechart">
              <div class="horiD">
                <!-- <div class="button-div1">
                  <button [ngClass]="test_version1 ? 'active-btn1' : 'inactive-btn1'" (click)="selectOption('avatar')">
                      <span>Avatar</span>
                  </button> 
                  <button [ngClass]="test_version1 ? 'inactive-btn1' : 'active-btn1'" (click)="selectOption('roleplay')">
                      <span>Roleplay</span>
                  </button>
              </div> -->
                 <div class="dropdown-div">
                  <mat-label class="LabelP">Type</mat-label>
                  <mat-select class="SelectD" (selectionChange)="selectOption($event.value)" placeholder="Select Option" value="Chat">
                    <mat-option value="Chat" >Chat</mat-option>
                    <mat-option value="Summarizer">Summarizer</mat-option>
                  </mat-select>
          </div> 
          <div class="Dropdown drop-linechart drop-line">
                      <mat-label class="LabelP">Timeframe</mat-label>
                      <mat-select class="SelectD" (selectionChange)="onTimeframeChange($event.value)" placeholder="Select" value="Today">
                          <mat-option class="selectD-option" value="Today">Today</mat-option>
                          <mat-option class="selectD-option" value="Current Week">Current Week</mat-option>
                          <mat-option class="selectD-option" value="Last Week">Last Week</mat-option>
                          <mat-option class="selectD-option" value="Last Month">Last Month</mat-option>
                          <mat-option class="selectD-option" value="Last 6 Months">Last 6 Months</mat-option>
                          <mat-option class="selectD-option" value="Last 1 Year">Last 1 Year</mat-option>
                      </mat-select>
                  </div>
              </div>
              <!-- <div class="LineBullets">
                  <div class="label">
                      <span class="bullet" style="background-color: rgba(255, 99, 132, 1);"></span> Avatar usage
                  </div>
                  <div class="label">
                      <span class="bullet" style="background-color:rgba(54, 162, 235, 1);"></span> {{this.config.RolePlay.DisplayText}}
                  </div>
              </div> -->
              <div class="Lineframe">
                  <canvas id="lineChart" class="CanvasLine"></canvas>
              </div>
          </div>
          
          </div>      

    </div>
</div>
</div>